// ── the private ring · the window events its surfaces share ─────────────────
//
// Three surfaces show the ring: the inbox (what waits on you), the you page
// (who reads what of you) and the access sheet (each app, managed). Each keeps
// its own read; these events keep them agreeing without a shared store:
//
//   ringChanged()          a decision or a setting landed: every surface reads again
//   openAccess(target?)    open the access sheet (mounted once in the dashboard),
//                          on one app when named, on "who has seen what" when asked
//
// Client-safe, no I/O. Nothing here carries a word of memory: an app is named
// by its kind and id only.

export const RING_CHANGED_EVENT = 'innernet:ring-changed'
export const OPEN_ACCESS_EVENT = 'innernet:open-access'

export interface AccessTarget {
  /** the app to open on (its row comes forward, opened) */
  app?: { kind: 'connection' | 'api_key'; id: string } | null
  /** which view: each app's access, or who has seen what */
  view?: 'apps' | 'seen'
}

/** say that the ring changed (the other surfaces read again). `from` names the
 *  sender, so it can ignore its own echo. */
export function ringChanged(from: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<{ from: string }>(RING_CHANGED_EVENT, { detail: { from } }))
}

/** open the access sheet */
export function openAccess(target: AccessTarget = {}): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<AccessTarget>(OPEN_ACCESS_EVENT, { detail: target }))
}
